import 'ui-theme/js/components/_drawer';

(function (UX) {
    var menu = (UX.menu = UX.menu || {});
    menu.on.listPosition.start = function () {};
    menu.on.listPosition.reset = function () {};
    menu.on.listPosition.handleHeightSet = function () {};
})(UX);
